import React from 'react';

export default function IconPencil({fill = '#90A0B7'}) {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.3735 3.21353L15.3606 1.2013C14.7327 0.573525 13.7131 0.573525 13.0855 1.2013L11.1922 3.09468L15.4491 7.3803L17.3434 5.48692C18.0032 4.85881 18.0032 3.84131 17.3735 3.21353ZM10.4372 3.85202L1.73926 12.5471C1.66444 12.6219 1.6135 12.7172 1.5927 12.8209L0.710509 17.2304C0.633309 17.6052 0.963913 17.9367 1.33903 17.863L5.74998 16.9811C5.85374 16.9604 5.94896 16.9094 6.02378 16.8347L14.7218 8.13955L10.4372 3.85202Z"
                fill={fill}
            />
        </svg>
    );
}



// WEBPACK FOOTER //
// ./components/icon_pencil/index.js